import { motion } from "framer-motion";
import { COURSES } from "@/data";
import { ArrowUpRight } from "lucide-react";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function Courses() {
  return (
    <section id="courses" data-testid="courses-section" className="py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-4">// Μαθήματα & Τμήματα</div>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight">
              Ένα πρόγραμμα για κάθε στόχο.
            </h2>
          </div>
          <button
            data-testid="courses-cta"
            onClick={() => scrollTo("contact")}
            className="font-mono-accent text-xs uppercase tracking-widest text-primary hover:text-accent transition-colors self-start md:self-auto"
          >
            Ζητήστε αναλυτικό πρόγραμμα →
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-border">
          {COURSES.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
              data-testid={`course-card-${i}`}
              className="group relative border-r border-b border-border p-8 lg:p-10 hover:bg-primary transition-colors duration-300"
            >
              <div className="flex items-start justify-between">
                <c.icon className="h-8 w-8 text-primary group-hover:text-white transition-colors" strokeWidth={1.5} />
                <span className="font-mono-accent text-[10px] uppercase tracking-widest text-muted-foreground group-hover:text-white/70 border border-border group-hover:border-white/30 rounded-full px-3 py-1 transition-colors">
                  {c.tag}
                </span>
              </div>
              <h3 className="font-heading font-bold text-xl mt-6 group-hover:text-white transition-colors">{c.title}</h3>
              <p className="text-sm text-muted-foreground mt-3 leading-relaxed group-hover:text-white/80 transition-colors">
                {c.desc}
              </p>
              <ArrowUpRight className="h-5 w-5 mt-6 text-primary group-hover:text-white opacity-0 group-hover:opacity-100 transition-all -translate-x-2 group-hover:translate-x-0" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
